import {FeaturesCards, FooterSection, Header, HeroSectionNew, PowerTagline, SignupBoxSection} from './sections';
import ReactGA from "react-ga4";
import {useEffect} from 'react';
import SEO from '../../components/common/SEO';
import {organizationSchema, websiteSchema, softwareApplicationSchema, videoObjectSchema} from '../../utils/structuredData';


const Home = () => {
  useEffect(()=>{
    if(process.env.REACT_APP_ENV === "production") {
      ReactGA.initialize("G-ZB9N7T58NE");
      ReactGA.send({ hitType: "pageview", page: "/", title: "Landing Home Page" });
    }
  },[])
  
  const combinedSchema = {
    '@context': 'https://schema.org',
    '@graph': [organizationSchema, websiteSchema, softwareApplicationSchema, videoObjectSchema]
  };

  return (
    <div className="relative min-w-full bg-black mx-auto ">
      <SEO
        title="CadencePro.ai | The AI Agent for Project Risk Management"
        description="Equip yourself with an AI agent that runs real-time simulations, revealing how scope, resource, or schedule changes impact cost, delivery, and portfolio health."
        canonical="/"
        keywords="project management, AI project planning, risk management, project simulation, resource planning, capacity planning, project estimation, agile planning, project risk analysis"
        structuredData={combinedSchema}
      />
      <Header />
      <div className="pointer-events-none absolute -top-6 left-2 w-72 h-48 opacity-40 bg-gradient-to-tr from-blue-700 via-indigo-800 to-blue-700 rounded-2xl blur-3xl" />
      <div className="pointer-events-none absolute bottom-[1050px] right-0 w-72 h-48 opacity-30 bg-gradient-to-tr from-blue-700 via-indigo-800 to-blue-700 rounded-2xl blur-3xl" />
      <div className="pointer-events-none absolute top-16 right-6 w-56 h-40 opacity-25 bg-gradient-to-tr from-blue-700 via-indigo-800 to-blue-700 rounded-2xl blur-3xl" />
      <div className="pointer-events-none absolute top-[780px] right-6 w-56 h-40 opacity-25 bg-gradient-to-tr from-blue-700 via-indigo-800 to-blue-700 rounded-2xl blur-3xl" />
      <div className="pointer-events-none absolute top-1/2 -translate-y-1/2 left-6 w-64 h-44 opacity-25 bg-gradient-to-tr from-blue-700 via-indigo-800 to-blue-700 rounded-2xl blur-3xl" />
      <div className="pointer-events-none absolute bottom-44 left-1/4 w-72 h-52 opacity-20 bg-gradient-to-tr from-blue-700 via-indigo-800 to-blue-700 rounded-2xl blur-3xl" />

      <HeroSectionNew />
      {/* <HeroSection /> */}
      {/* <Features /> */}
      <PowerTagline />
      <FeaturesCards />
      <SignupBoxSection />
      <FooterSection />
      {/*<footer className="px-10 bg-gray-900">*/}
      {/*    <img className="w-full" src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/cadencepro.ai.png" alt="" />*/}
      {/*</footer>*/}
    </div>
  )
};

export default Home;
